import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { Loader, Header } from 'semantic-ui-react'
import { Modal } from 'react-bootstrap'
import { LOAD_MERGING_USER } from '../../../../../graphql/user'
import Preview from './Preview'
import JobConflicts from './JobConflicts'
import DeleteSourceUser from './DeleteSourceUser'
import ConfirmMerge from './ConfirmMerge'
import './style.css'

const MergeContent = ({ sourceUser, targetUser, onClose }) => {
    const [page, setPage] = useState('PREVIEW')
    const [mergeData, setMergeData] = useState({
        sourceUser,
        targetUser,
        deleteSourceUser: false,
        isSourceClient: sourceUser.membership.length > 0,
        jobsToRemove: [],
    })

    const updateMergeData = (data) => setMergeData({ ...mergeData, ...data })

    const PAGES = {
        PREVIEW: <Preview mergeData={mergeData} setPage={setPage} />,
        JOB_CONFLICTS: (
            <JobConflicts
                mergeData={mergeData}
                updateMergeData={updateMergeData}
                setPage={setPage}
            />
        ),
        DELETE_SOURCE: (
            <DeleteSourceUser
                mergeData={mergeData}
                updateMergeData={updateMergeData}
                setPage={setPage}
            />
        ),
        CONFIRM: (
            <ConfirmMerge
                mergeData={mergeData}
                updateMergeData={updateMergeData}
                setPage={setPage}
                onClose={onClose}
            />
        ),
    }
    return PAGES[page]
}

const MergeModal = ({ sourceEmail, targetEmail, onClose }) => {
    // Use fetch policy 'network-only' to always know if the email has been merged already or not
    const { data: sourceUserData, loading: sourceUserLoading } = useQuery(
        LOAD_MERGING_USER,
        {
            fetchPolicy: 'network-only',
            variables: { email: sourceEmail },
        }
    )
    const { data: targetUserData, loading: targetUserLoading } = useQuery(
        LOAD_MERGING_USER,
        {
            fetchPolicy: 'network-only',
            variables: { email: targetEmail },
        }
    )

    const renderModalContent = () => {
        if (sourceUserLoading || targetUserLoading) {
            return <Loader active />
        }
        const sourceUser = sourceUserData?.userByEmail
        const targetUser = targetUserData?.userByEmail
        if (!sourceUser) {
            return (
                <Header
                    as="h4"
                    color="red"
                    content={`Fail to find the user account for ${sourceEmail}`}
                />
            )
        }
        if (!targetUser) {
            return (
                <Header
                    as="h4"
                    color="red"
                    content={`Fail to find the user account for ${targetEmail}`}
                />
            )
        }
        if (!sourceUser.expert) {
            return (
                <Header
                    as="h4"
                    color="red"
                    content={`Fail to find the expert profile for ${sourceEmail}`}
                />
            )
        }
        if (!targetUser.expert) {
            return (
                <Header
                    as="h4"
                    color="red"
                    content={`Fail to find the expert profile for ${targetEmail}`}
                />
            )
        }
        return (
            <MergeContent
                sourceUser={sourceUser}
                targetUser={targetUser}
                onClose={onClose}
            />
        )
    }

    return (
        <Modal
            show
            onHide={onClose}
            centered
            size="lg"
            style={{ zIndex: 9999 }}
        >
            <Modal.Header closeButton>
                <Modal.Title>Merge expert profiles</Modal.Title>
            </Modal.Header>
            <Modal.Body>{renderModalContent()}</Modal.Body>
        </Modal>
    )
}

export default MergeModal
